import { create } from "zustand";
import {
  addUser,
  createGroup,
  deleteGroup,
  groups,
  removeUser,
  userGroup,
  users,
} from "../api_layer/api";

export const useGroupManagement = create((set) => ({
  groupData: [],
  userData: [],
  updateData: [],
  groupIdData: [],
  groupLoading: false,
  userLoading: false,
  createLoading: false,
  postUserLoading: false,
  removeUserLoading: false,
  deleteGroupLoading: false,
  idLoading: false,
  error: null,
  fetchGroupData: async () => {
    try {
      set({ groupLoading: true, error: null });
      const response = await groups();
      set({ groupData: response.data, groupLoading: false });
    } catch (error) {
      set({ error: error.message, groupLoading: false });
    }
  },
  fetchUserData: async () => {
    try {
      set({ userLoading: true, error: null });
      const response = await users();
      set({ userData: response.data, userLoading: false });
    } catch (error) {
      set({ error: error.message, userLoading: false });
    }
  },
  fetchUserGroup: async (id) => {
    try {
      set({ idLoading: true, error: null });
      const response = await userGroup(id);
      set({ groupIdData: response.data, idLoading: false });
    } catch (error) {
      set({ error: error.message, idLoading: false });
    }
  },
  postUser: async (id, payload, fetchUserGroup, setAssigneeId, setMessage) => {
    try {
      set({ postUserLoading: true, error: null });
      const response = await addUser(id, payload);
      fetchUserGroup(id);
      setAssigneeId(null);
      setMessage({ message: `user Successfully Added`, color: "primary" });
      set({ postUserLoading: false });
    } catch (error) {
      setMessage({ message: error.response.data.message, color: "danger" });
      set({ error: error.message, postUserLoading: false });
    }
  },
  deleteRemoveUser: async (id, payload, fetchUserGroup, setMessage) => {
    try {
      set({ removeUserLoading: true, error: null });
      const response = await removeUser(id, payload);
      setMessage({ message: "User Removed successfully", color: "primary" });
      fetchUserGroup(id);
      set({ removeUserLoading: false });
    } catch (error) {
      setMessage({ message: error.response.data.message, color: "danger" });
      set({ error: error.message, removeUserLoading: false });
    }
  },
  createdGroup: async (
    payload,
    setToaster,
    fetchGroupData,
    handleModalShow
  ) => {
    try {
      set({ createLoading: true, error: null });
      const response = await createGroup(payload);
      setToaster(
        "Add User",
        `Group "${payload?.name}" created Successfully`,
        "success"
      );
      set({ createLoading: false });
      fetchGroupData();
      handleModalShow();
    } catch (error) {
      if (handleModalShow) {
        handleModalShow();
      }
      setToaster("Add User", error?.response?.data?.message, "danger");
      set({ error: error.message, createLoading: false });
    }
  },
  deletedGroup: async (id, setToaster, fetchGroupData) => {
    try {
      set({ deleteGroupLoading: true, error: null });
      const response = await deleteGroup(id);
      setToaster("Delete Group", "Group Deleted Successfully", "success");
      set({ deleteGroupLoading: false });
      fetchGroupData();
    } catch (error) {
      setToaster("Add User", error.response.data.message, "danger");
      set({ error: error.message, deleteGroupLoading: false });
    }
  },
}));
